<template>
	<div class="icon-card flex-centerize" :style="`min-height: ${width + 8}px; min-width: ${width + 8}px`">
		<SIcon v-if="iconName" :width="width" :name="iconName" />
	</div>
</template>

<script>
export default {
	name: 'InsertDataPreviewIcon',
	props: {
		iconName: { type: String },
		width: { type: [String, Number], default: 11 },
	},
};
</script>
<style lang="scss">
.icon-card {
	border-radius: 4px;
	border: 1px solid var(--border-color);
}
</style>
